import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import UncategorisedCard from '@/components/elements/UncategorisedCard.vue';
import TransactionBulkPage from '@/components/TransactionBulkPage.vue';
import SuccessToast from '@/components/elements/SuccessToast.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopUncategorisedBulk',
    props: {
        count: {},
        range: {},
        colourMode: {}
    },
    emits: ["categorised", "view-transaction"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const bulkOpen = ref(false);
        const categorisedToastCount = ref(0);
        function onBulkClose(categorisedCount = 0) {
            bulkOpen.value = false;
            // Nothing categorised — host data is unchanged, so don't trigger a revalidate.
            if (categorisedCount <= 0)
                return;
            categorisedToastCount.value = categorisedCount;
            emit('categorised', categorisedCount);
        }
        return (_ctx, _cache) => {
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.count > 0)
                    ? (_openBlock(), _createBlock(UncategorisedCard, {
                        key: 0,
                        count: _ctx.count,
                        class: _normalizeClass(["dub-card", _ctx.colourMode]),
                        onClick: _cache[0] || (_cache[0] = ($event) => (bulkOpen.value = true))
                    }, null, 8, ["count", "class"]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_dialog, {
                    modelValue: bulkOpen.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((bulkOpen).value = $event)),
                    "max-width": "520",
                    scrim: "rgba(0, 0, 0, 0.5)"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: _normalizeClass(["bulk-host", _ctx.colourMode])
                        }, [
                            (bulkOpen.value)
                                ? (_openBlock(), _createBlock(TransactionBulkPage, {
                                    key: 0,
                                    embedded: "",
                                    fromDate: _ctx.range.from,
                                    toDate: _ctx.range.to,
                                    initialCount: _ctx.count,
                                    onClose: onBulkClose,
                                    onTransactionClick: _cache[1] || (_cache[1] = (t) => emit('view-transaction', t))
                                }, null, 8, ["fromDate", "toDate", "initialCount"]))
                                : _createCommentVNode("", true)
                        ], 2)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SuccessToast, {
                    count: categorisedToastCount.value,
                    "onUpdate:count": _cache[3] || (_cache[3] = ($event) => ((categorisedToastCount).value = $event))
                }, null, 8, ["count"])
            ], 64));
        };
    }
});
